import UploadsIndex from "./UploadsIndex";
export default UploadsIndex;
